import type { PropsWithChildren, ReactElement } from 'react';
import RaceRosterLogo from '../../../components/racer-roster-logo/RaceRosterLogo';
import { Div, Flex } from '@fastnorth/kraken/components/layout';
import Separator from '@fastnorth/kraken/components/separator';
import { Text } from '@fastnorth/kraken/components/typography';

export type RaceProgressPageLayoutProps = PropsWithChildren<{
  eventName: string;
  onPageTopElementChange?: (element: HTMLDivElement | null) => void;
}>;

const RaceProgressPageLayout = ({
  children,
  eventName,
  onPageTopElementChange,
}: RaceProgressPageLayoutProps): ReactElement => (
  <Flex className="min-h-screen flex-col bg-white" data-testid="race-progress-page-layout">
    <Div
      ref={onPageTopElementChange}
      className="scroll-mt-0 border-b border-border bg-white px-4 py-5 outline-none focus:outline-none md:px-9 md:py-9"
      data-testid="race-progress-page-top-bar"
      spacing="0"
      tabIndex={-1}>
      <Flex className="mx-auto w-full max-w-[992px] items-center gap-4 md:gap-5">
        <RaceRosterLogo layout="horizontal" />
        <Flex className="items-center gap-5 md:gap-6 text-sm leading-normal">
          <Div aria-hidden className="h-[1lh] shrink-0 self-center">
            <Separator orientation="vertical" />
          </Div>
          <Text color="muted" size="sm">
            {eventName}
          </Text>
        </Flex>
      </Flex>
    </Div>
    <Div className="flex-1 bg-[hsl(var(--blue-dark))] px-2 py-6 md:px-6 md:py-8">
      <Div
        className="mx-auto w-full max-w-[992px] rounded-[32px] border border-b-gray-400 bg-white pb-7 pt-9 shadow-lg"
        data-testid="race-progress-page-card">
        {children}
      </Div>
    </Div>
  </Flex>
);

export default RaceProgressPageLayout;
